import { render, staticRenderFns } from "./email-not-valid.vue?vue&type=template&id=65eccb26&scoped=true"
import script from "./email-not-valid.vue?vue&type=script&lang=ts"
export * from "./email-not-valid.vue?vue&type=script&lang=ts"
import style0 from "./email-not-valid.vue?vue&type=style&index=0&id=65eccb26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65eccb26",
  null
  
)

export default component.exports